export const LOGIN_TEXTS = {
    TOAST_MESSAGES: {
        REGISTER_SUCCESS: "Registro exitoso. Por favor, inicia sesión.",
        PASSWORD_CHANGED: "¡Esoooo! Cambiaste tu contraseña exitosamente. ¡Ahora ingresa y disfruta de todo lo que Wuuju™ tiene para ti!"
    },
    MAIN_TITLE: "Inicia sesión en tu Wuuju-cuenta♡",
    LOGIN_BUTTON_LABEL: "Iniciar Sesion",
    SOCIAL_LOGIN_TEXT: "Ingresa también con",
    GOOGLE_LOGIN_LABEL: "Inicia sesión con Google",
    FACEBOOK_LOGIN_LABEL: "Inicia sesión con Facebook",
    FORGOT_PASSWORD_TEXT: "¿Olvidaste tu contraseña?",
    REGISTER_PROMPT: "¿Aún no tienes una Wuuju-cuenta?.",
    REGISTER_LINK_TEXT: "¡Regístrate, es gratis!"
};